/**
 * License Intelligence SAP Identity Distribution Mock Data
 *
 * Mock data for the identity distribution API endpoint.
 * In production, this data will come from:
 * GET /ECMv6/api/sodms/license-intelligence/v1/sap/overview/identity-distribution
 */

import type { IdentityTypeDistributionData } from '../components/Details/Overview/OverviewContent/type';

interface IdentityDistributionResponse {
  data: IdentityTypeDistributionData;
  status: number;
  message: string;
}

export const LICENSE_INTELLIGENCE_IDENTITY_DISTRIBUTION_DATA: IdentityDistributionResponse =
  {
    data: {
      segments: [
        {
          type: 'Human',
          consumedUnit: 3502.77,
          percentage: 91.0,
        },
        {
          type: 'Service Account',
          consumedUnit: 230.82,
          percentage: 6.0,
        },
        {
          type: 'Batch',
          consumedUnit: 80.79,
          percentage: 2.1,
        },
        {
          type: 'Emergency',
          consumedUnit: 32.62,
          percentage: 0.9,
        },
      ],
      totalUnit: 3847,
    },
    status: 200,
    message: 'Identity distribution data retrieved successfully',
  };

export default LICENSE_INTELLIGENCE_IDENTITY_DISTRIBUTION_DATA;
